import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { YouTubePlayer } from '@angular/youtube-player';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  selector: 'lib-web-shared-ui-lib-video-popup',
  imports: [YouTubePlayer],
  templateUrl: './lib-video-popup.component.html',
  styleUrl: './lib-video-popup.component.scss',
})
export class LibVideoPopupComponent {
  private readonly loggingService = inject(LoggingService);
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: { url: string }) {
    data.url = this.findVideoId(data.url);
    this.loggingService.warn('@@@ Video popup @@@', data.url);
  }

  findVideoId(url: string) {
    return url.split('/')[3].split('?')[0];
  }
}
